import React, { useRef, useState } from "react";
import { Button } from "primereact/button";
import ModalShell from "../../../components/Modal/ModalShell";
import QuestionnaireBuilder from "../../../components/CompositeComponents/QuestionnaireBuilder/QuestionnaireBuilder";

export default function QuestionnairePreview({ name, questions, onHide }) {
  const [index, setIndex] = useState(0);
  const [answers, setAnswers] = useState({});
  const builder = useRef(null);
  const current = questions[index];
  const next = () => {
    if (!builder.current?.validate()) return;
    if (index < questions.length - 1) setIndex((value) => value + 1);
    else onHide();
  };
  return (
    <ModalShell visible title="Vista previa" width="48rem" onHide={onHide} className="q-preview"
      footer={<div className="q-preview-footer">
        <Button type="button" icon="pi pi-refresh" text aria-label="Reiniciar vista previa" tooltip="Reiniciar vista previa"
          onClick={() => { setAnswers({}); setIndex(0); builder.current?.reset(); }} />
        <div>
          <Button type="button" icon="pi pi-arrow-left" label="Anterior" text disabled={index === 0} onClick={() => setIndex((value) => value - 1)} />
          <Button type="button" icon={index < questions.length - 1 ? "pi pi-arrow-right" : "pi pi-check"} iconPos="right"
            label={index < questions.length - 1 ? "Siguiente" : "Finalizar vista previa"} onClick={next} disabled={!current} />
        </div>
      </div>}>
      <h2 className="q-preview-name">{name || "Cuestionario sin título"}</h2>
      <p className="q-preview-progress" role="status">Pregunta {index + 1} de {questions.length}</p>
      {current && <QuestionnaireBuilder key={current.id} ref={builder} questions={[current]}
        initialAnswers={answers} multiDisplay="checkbox" validateOnChange={false}
        onChange={(questionId, value) => setAnswers((previous) => ({ ...previous, [questionId]: value }))} />}
    </ModalShell>
  );
}
